import React from 'react';

import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HeroImg4 from '../components/HeroImg4';
import AboutContent from '../components/AboutContent';

const About = () => {
  return (
    <div>
      <Navbar/>
     <HeroImg4/>
      <AboutContent/>
      <Footer/>
    </div>
  )
}

export default About